<template>
	<div class="s-summary">
		<h2 class="mdc-typography--headline2 s-summary__title">{{ i18n.summary[locale] }}</h2>
		<div class="s-summary__intro">
			<p
				v-for="(item, index) in isPublic
					? i18n.summaryIntroPublic[locale]
					: i18n.summaryIntro[locale]"
				v-bind:key="index"
			>
				{{ item }}
			</p>
		</div>
		<div class="s-summary__cols">
			<div class="s-summary__result">
				<ul class="s-summary__list">
					<li
						v-for="(item, index) in summary"
						v-bind:key="index"
						class="s-summary__list-item"
						v-bind:class="{
							's-summary__list-item--inactive': !item.isChecked(data)
						}"
					>
						<i
							class="material-icons s-summary__list-icon"
							role="presentation"
							v-bind:class="{
								's-summary__list-icon--inactive': !item.isChecked(data)
							}"
							>exit_to_app
						</i>
						{{ isPublic ? item.titlePublic[locale] : item.title[locale] }}
					</li>
				</ul>
			</div>
			<div class="s-summary__actions">
				<div class="mdc-card mdc-card--outlined ln-teaser s-summary__actions-card">
					<div class="ln-teaser__content s-summary__actions-content">
						<div class="s-summary__actions-account" v-if="isPublic">
							<a
								:href="this.getSignupUrl()"
								class="mdc-button mdc-button--raised s-summary__actions-button"
								data-event="register"
							>
								<i class="material-icons mdc-button__icon" role="presentation"
									>add_circle_outline</i
								>
								{{ i18n.signup[locale] }}</a
							>
							<a
								:href="getLoginUrl()"
								class="mdc-button mdc-button--raised s-summary__actions-button"
								data-event="login"
							>
								<i class="material-icons mdc-button__icon" role="presentation"
									>lock_open</i
								>
								{{ i18n.login[locale] }}</a
							>
						</div>
						<div class="s-summary__actions-account" v-else>
							<a
								:href="getDashboardUrl()"
								class="mdc-button mdc-button--raised s-summary__actions-button"
							>
								<i class="material-icons mdc-button__icon" role="presentation"
									>dashboard
								</i>
								{{ i18n.dashboard[locale] }}</a
							>
						</div>
						<div class="s-summary__actions-print">
							<a
								:href="getPrintUrl()"
								class="mdc-button mdc-button--outlined s-summary__actions-button"
								target="_blank"
							>
								<i class="material-icons mdc-button__icon" role="presentation"
									>print</i
								>
								{{ i18n.print[locale] }}
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Summary',
	props: {
		summary: Array,
		data: Object,
		i18n: Object,
		isPublic: Boolean,
		getSignupUrl: Function,
		getLoginUrl: Function,
		getDashboardUrl: Function,
		getPrintUrl: Function,
		track: Function,
		locale: {
			type: String,
			default: 'de'
		}
	}
};
</script>

<style lang="scss">
.s-app .s-summary {
	@import '@legacynotes/frontend/src/assets/css/variables-new';
	@import '@legacynotes/frontend/src/assets/css/mixins-new';

	&__title.mdc-typography--headline2 {
		margin-top: 0;
	}

	&__intro {
		margin-bottom: 2rem;
	}

	&__cols {
		display: flex;
		margin-left: -0.75rem;
		margin-right: -0.75rem;

		@include ln-mq-mobile {
			display: block;
		}
	}

	&__result {
		flex: 2;
		margin-left: 0.75rem;
		margin-right: 0.75rem;

		@include ln-mq-mobile {
			padding-right: 0;
		}
	}

	&__list {
		list-style: none;
		padding: 0;
		margin: 0;

		&-item {
			padding-left: 3rem;
			position: relative;

			&:not(:last-child) {
				margin-bottom: 1rem;
			}

			&--inactive {
				opacity: 0.4;
			}
		}

		&-icon {
			position: absolute;
			left: 0;
			color: $mdc-theme-primary;

			&--inactive {
				color: inherit;

				&.material-icons {
					opacity: 0.5;
				}
			}
		}
	}

	&__actions {
		flex: 1;
		margin-left: 0.75rem;
		margin-right: 0.75rem;

		&-card.mdc-card {
			background: rgb(243, 243, 243);
		}

		&-content {
			display: flex;
			flex-direction: column;
		}

		&-account {
			flex: 1;
			margin-bottom: 2rem;
		}

		&-button {
			width: 100%;

			&.mdc-button.mdc-button {
				margin-left: 0;

				&.mdc-button--raised {
					color: $mdc-theme-on-secondary;
				}
			}

			&:not(:last-child) {
				margin-bottom: 1rem;
			}
		}

		@include ln-mq-mobile {
			padding-left: 0;
			margin-top: 2rem;
		}

		@media print {
			display: none;
		}
	}
}
</style>
